import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  time: {
    padding: 0,
    width: "100%",
    "& .MuiInputBase-root.MuiInput-root": {
      "&:before": {
        borderBottom: "none",
      },
      "&:after": {
        borderBottom: "none",
      },
    },
    "& .MuiInputBase-input.MuiInput-input": {
      padding: 0,
      fontSize: "14px",
      fontStyle: "normal",
      fontWeight: "400",
      lineHeight: "normal",
      [theme.breakpoints.down("mobile")]: {
        fontSize: "12px",
      },
    },
  },
}));

export default useStyles;
